import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=7c2bbf27&"
import script from "./ChatList.vue?vue&type=script&lang=ts&"
export * from "./ChatList.vue?vue&type=script&lang=ts&"
import style0 from "./ChatList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports